import { render, staticRenderFns } from "./ImportColumnField.vue?vue&type=template&id=288b25b0&"
import script from "./ImportColumnField.vue?vue&type=script&lang=js&"
export * from "./ImportColumnField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288b25b0')) {
      api.createRecord('288b25b0', component.options)
    } else {
      api.reload('288b25b0', component.options)
    }
    module.hot.accept("./ImportColumnField.vue?vue&type=template&id=288b25b0&", function () {
      api.rerender('288b25b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Import/Components/ImportColumnField.vue"
export default component.exports